<div class="mat-dialog-wrapper">
  <div class="d-flex justify-space-between align-items-center mb-1">
    <h2 mat-dialog-title class="m-0">{{(this.data?.row?.id)?'Edit':'Add'}} {{(this.data?.type)?'Accounting Policies':'Notes'}}</h2>
    <button
      mat-button
      class="header-text-close d-flex align-items-center"
      disableRipple
      (click)="onCloseClick()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div>
      <form [formGroup]="form">
        <div>
          <div class="form-field">
            <p>
              Title <span class="text-danger-300">*</span>
            </p>
            <mat-form-field>
              <input
                matInput
                formControlName="title"
                autocomplete="off"
                appAutoFocusDirective
                required
              />
            </mat-form-field>
          </div>

          <div class="form-field">
            <p>
              Note Content <span class="text-danger-300">*</span>
            </p>
             <div class="notes-section">
                <ejs-richtexteditor
                  [toolbarSettings]="
                    commonService.syncfusionRichTextEditorToolbarSettings
                  "
                  (actionBegin)="
                    commonService.syncfusionRichTextEditorOnActionBegin($event)
                  "
                  [enableXhtml]="true"
                  [toolbarSettings]="commonService.syncfusionRichTextEditorTools"
                  formControlName="noteContents"
                  [enableHtmlSanitizer]="true"
                  [pasteCleanupSettings]="
                    commonService.syncfusionRichTextEditorPasteCleanupSettings
                  "
                ></ejs-richtexteditor>
            </div>
          </div>
        </div>
      </form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button
      class="action-button primary-button mr-1"
      type="button"
      mat-button
      disableRipple
      (click)="onSave()"
    >
      Save
    </button>
    <button
      class="action-button secondary-button"
      type="button"
      mat-button
      disableRipple
     (click)="onReset()"
    >
      Clear Form
    </button>
  </mat-dialog-actions>

</div>

